import { z } from "zod";

export const ClienteCentroCustoSchema = z.object({
    idClienteCentroCusto: z.number().int().optional(),
    idCliente: z.number().int().optional(),
    idCentroCusto: z.number().int().optional(),
    unidade: z.string().optional().nullable(),
    principal: z.coerce.number().default(1),

});

export type ClienteCentroCustoForm = z.infer<typeof ClienteCentroCustoSchema>;

export const defaultClienteCentroCustoForm: Partial<ClienteCentroCustoForm> = {
    idClienteCentroCusto: undefined,
    idCliente: undefined,
    idCentroCusto: undefined,
    unidade: undefined,
    principal: 1,

};
